import { connect } from 'react-redux'

import Filter from 'components/filter/Filter'
import {
  updateSurveyFilters,
  getSurveyDynFilterValues,
  setKeySurveyFilterSelected
} from 'redux/actions/surveyActions';

const mapStateToProps = (state, ownProps) => {
  return {
    filters: state.survey.surveyManager.filters
      ? state.survey.surveyManager.filters
      : [],
    currentFilters: state.survey.surveyManager.currentFilters
      ? state.survey.surveyManager.currentFilters
      : [],
    deps:
      ownProps.depKey && state.survey.surveyManager.currentFilters
      ? state.survey.surveyManager.currentFilters || []
      : [],
    filterTargetKey: ownProps.filterTargetKey,
    placeholder: ownProps.placeholder,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addFilter: values =>
      dispatch(updateSurveyFilters(ownProps.filterTargetKey, values)),
    getDynFilterValues: () =>
      dispatch(getSurveyDynFilterValues(ownProps.filterTargetKey)),
    setKeyFilterSelected: () =>
      dispatch(setKeySurveyFilterSelected(ownProps.filterTargetKey))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Filter)


// WEBPACK FOOTER //
// src/components/survey/gestion/SurveyList/SurveyListGrid/SurveyFilterContainer.js